<template>
  <div :id="id" :class="className" :style="{height:height,width:width}" />
</template>

<script>

import * as echarts from 'echarts'
import resize from '@/utils/mixins/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    goodsOrder: {
      type: null,
      default: ''
    }
  },
  data() {
    return {
      chart: null,
      options: {
        backgroundColor: '#fff',
        width: '90%',
        title: {
          show: false,
          text: '订单',
          x: '20',
          top: '20',
          textStyle: {
            color: '#fff',
            fontSize: '22'
          },
          subtextStyle: {
            fontSize: '16'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '5%',
          right: '5%',
          borderWidth: 0,
          top: 40,
          bottom: 40,
          textStyle: {}
        },
        // legend: {
        //   left: 'center',
        //   top: '5%',
        //   itemGap: 50,
        //   itemWidth: 14,
        //   itemHeight: 14,
        //   textStyle: {
        //     color: '#90979c'
        //   },
        //   data: ['本期', '去年同期']
        // },
        calculable: true,
        xAxis: [{
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#90979c'
            }
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitArea: {
            show: false
          },
          axisLabel: {
            interval: 0
          },
          data: []
        }],
        yAxis: [{
          type: 'value',
          minInterval: 1,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee'
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#90979c'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0
          },
          splitArea: {
            show: false
          }
        }],
        // dataZoom: [
        //   {
        //     show: true,
        //     height: 10,
        //     xAxisIndex: [
        //       0
        //     ],
        //     bottom: 5,
        //     startValue: 0,
        //     endValue: 16,
        //     handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
        //     handleSize: '110%',
        //     handleStyle: {
        //       color: '#d3dee5'
        //     },
        //     textStyle: {
        //       color: '#fff'
        //     },
        //     borderColor: '#90979c'
        //   },
        //   {
        //     type: 'inside',
        //     show: true,
        //     height: 15,
        //     start: 1,
        //     end: 35,
        //     zoomOnMouseWheel: false
        //   }
        // ],
        series: [
          {
            name: '去年同期',
            type: 'bar',
            itemStyle: {
              normal: {
                color: '#2298F0',
                barBorderRadius: 0,
                label: {
                  show: true,
                  position: 'top',
                  formatter(p) {
                    return p.value > 0 ? p.value : ''
                  }
                }
              }
            },
            data: []
          },
          {
            name: '本期',
            type: 'bar',
            itemStyle: {
              normal: {
                color: '#FF7800',
                barBorderRadius: 0,
                label: {
                  show: true,
                  position: 'top',
                  formatter(p) {
                    return p.value > 0 ? p.value : ''
                  }
                }
              }
            },
            data: []
          }
        ]
      }
    }
  },
  watch: {
    goodsOrder(value) {
      this.goodsOrder = value
      console.log(this.goodsOrder)
      this.initChart()
    }
  },
  created() {
  },
  mounted() {
    this.chart = echarts.init(document.getElementById(this.id))
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      const vm = this
      // 未获取数据前，显示loading加载动画
      if (vm.goodsOrder == null || vm.goodsOrder === '') {
        vm.chart.showLoading()
      } else {
        vm.chart.hideLoading()
        const { list } = this.goodsOrder
        const options = vm.options

        const timeLine = Object.keys(list)
        const nowDate = Object.values(list).map(i => {
          return i.current
        })
        const oldDate = Object.values(list).map(i => {
          return i.lastCurrent
        })
        options.xAxis[0].data = timeLine
        options.series[1].data = nowDate
        options.series[0].data = oldDate
        vm.chart.setOption(options, true)
      }
    }
  }
}
</script>
